import { DynamicEnvironment } from './dynamic-environment';

class Environment extends DynamicEnvironment {
  public production: boolean;
  public integration: boolean;
  public API_URL: string = '';
  public WSO2_signInRedirectURL: string = '';
  public WSO2_signOutRedirectURL: string = '';
  public WSO2_clientID: string = '';
  public WSO2_baseUrl: string = '';
  public WSO2_scope: Array<string> = [];
  public sso: SSOConfig = new SSOConfig();
  public azureSSO: AzureSSOConfig = new AzureSSOConfig();
  public coreApp: CoreApp = new CoreApp();

  constructor() {
    super();
    this.production = false;
    this.integration = true;
  }
}
class AzureSSOConfig {
  public clientId: string = '';
  public authority: string = '';
  public redirectUri: string = '';
  public postLogoutRedirectUri: string = '';
  public scopes: string[] = [];
}

class SSOConfig {
  public clientId: string = '';
  public clientSecret: string = '';
  public serverUrl: string = '';
  public issuer: string = '';
  public redirectUri: string = '';
  public scope: string = '';
  public tokenEndpoint: string = '';
  public userinfoEndpoint: string = '';
  public authorizationEndpoint: string = '';
  public jwksEndpoint: string = '';
  public sessionCheckIFrameUrl: string = '';
  public showDebugInformation: boolean = false;
  public requireHttps: boolean = false;
  public responseType: string = '';
  public logoutUrl: string = '';
  public postLogoutRedirectUri: string = '';
  public useHttpBasicAuth: boolean = true;
}

class CoreApp {
  public url: string = '';
}

export const environment = new Environment();
